import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class AdminDailySummaryApi extends BaseApi {
  async getAdminDailySummaryCount(
    params: APIPaths["/admin-dash/admin-daily-summary/summary_count"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/admin-dash/admin-daily-summary/summary_count"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get("/admin-dash/admin-daily-summary/summary_count", { params })).data;
  }
}
